import ClientCreateContainer from "./ClientCreateContainer";
export default ClientCreateContainer;
